import { ReactComponent as SearchIcon } from './search.svg';

export default SearchIcon;
